import { LogLevel } from "@azure/msal-browser";
import { getAzureAuthClientId } from "../utils";

const clientId = getAzureAuthClientId();
const msalSetup = {
  auth: {
    clientId: clientId,
    authority:
      "https://login.microsoftonline.com/db05faca-c82a-4b9d-b9c5-0f64b6755421/",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },

  system: {
    loggerOptions: {
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii) {
          console.log(message);
        }
      },
    },
    navigateToLoginRequestUrl: true,
  },
};

export default msalSetup;